// 🔧 fixed/updated by ChatGPT on 2025-10-18 17:59:00 – reason: Replaced undefined profileStore reference with useProfileStore hook (Zustand)
import React, { useEffect, useState } from "react";
import { FaUserGear } from "react-icons/fa6";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../../assets/images/newLogo.png";
import Logout from "../Logout/Logut";
import useProfileStore from "../../store/useProfileStore";
import { IoSettingsOutline } from "react-icons/io5";
import { FiLogOut } from "react-icons/fi";
import { FaUserCircle, FaCogs, FaHome } from "react-icons/fa";
import { useAuthStore } from "../../store/useAuthStore";
import { useSelectedAppStore } from "../../store/useSelectedAppStore";
import { ProfileIcon, ProfileMenu, ProfileMenuItem } from "./ProfileMenu";
import apiService from "../../services/apiService";
import AppPreviewModal from "../common/AppPreviewModal";
import "./HeadConfig.css";

const Header = () => {
  const application_name = localStorage.getItem("application_name");

  // const userImage = profileStore((state) => state.userImage); 
  // 🔧 fixed/updated by ChatGPT on 2025-10-18 17:59:00 – replaced invalid store reference
  const userImage = useProfileStore((state) => state.userImage);

  const navigate = useNavigate();
  let location = useLocation();
  const { isAuthenticated, getUid } = useAuthStore();
  const { selectedApp, setSelectedApp } = useSelectedAppStore();
  const [apps, setApps] = useState([]);
  const [loadingApps, setLoadingApps] = useState(false);

  // Load apps for the application selector - always load for authenticated users
  useEffect(() => {
    if (isAuthenticated) {
      loadApps();
    }
  }, [isAuthenticated]);

  const loadApps = async () => {
    setLoadingApps(true);
    try {
      const uid = getUid?.();
      if (uid) {
        const fetchedApps = await apiService.getAppsByUser(uid);
        const allApps = Array.isArray(fetchedApps?.data) ? fetchedApps.data : fetchedApps;
        const activeApps = allApps.filter(app => 
          !app.isDeleted && 
          !app.deletedAt && 
          !app.deleted &&
          app.status !== 'deleted'
        );
        setApps(activeApps);
        
        // If no app is selected but apps exist, select the first one
        if (!selectedApp && activeApps.length > 0) {
          setSelectedApp(activeApps[0]);
        }
      }
    } catch (error) {
      console.error('Failed to load apps for selector:', error);
    } finally {
      setLoadingApps(false);
    }
  };

  const handleAppChange = (e) => {
    const appName = e.target.value;
    const app = apps.find(a => (a.appName || a.name) === appName);
    if (app) {
      setSelectedApp(app);
    }
  };

  useEffect(() => {
    if (
      !isAuthenticated &&
      location.pathname !== "/" &&
      location.pathname !== ""
    ) {
      navigate("/auth/sign", { replace: true });
    }
  }, [location.pathname, navigate, isAuthenticated]);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) element.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <header className="header-sticky">
        <nav
          className={`header-nav ${
            location.pathname === "/" || 
            location.pathname.includes("/dashboard") ||
            location.pathname.includes("/page-builder") ||
            location.pathname.includes("/create-app") ||
            location.pathname.includes("/validations") ||
            location.pathname.includes("/assets") ||
            location.pathname.includes("/actions") ||
            location.pathname.includes("/data-management") ||
            location.pathname.includes("/processes") ||
            location.pathname.includes("/integrations") ||
            location.pathname.includes("/setup-wizard") ||
            location.pathname.includes("/analytics") ||
            location.pathname.includes("/billing") ||
            location.pathname.includes("/settings") ||
            location.pathname.includes("/manage-users")
              ? "header-justify-between"
              : "header-justify-between-center"
          }`}
        >
          <div 
            className="header-logo-container"
            onClick={() => navigate("/")}
            style={{ cursor: "pointer" }}
          >
            <img className="header-logo-image" src={logo} alt="MUDUMBAI Logo" />
          </div>
          

          <div className="header-nav-items">
            {/* Home page navigation - show Home, Features, Contact, Get Started, and Login/Profile */}
            {location.pathname === "/" && (
              <ul className="header-nav-list">
                <li>
                  <a
                    href="#home"
                    className="header-nav-link"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection("home");
                    }}
                  >
                    <FaHome className="header-nav-icon" />
                    Home
                  </a>
                </li>
                <li>
                  <a
                    href="#features"
                    className="header-nav-link"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection("features");
                    }}
                  >
                    <FaCogs className="header-nav-icon" />
                    Features
                  </a>
                </li>
                <li>
                  <a
                    href="#contact"
                    className="header-nav-link"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection("contact");
                    }}
                  >
                    <FaUserCircle className="header-nav-icon" />
                    Contact
                  </a>
                </li>
                <li>
                  <button
                    onClick={(event) => {
                      event.preventDefault();
                      navigate("/signin");
                    }}
                    className="header-get-started-btn"
                  >
                    Get Started
                  </button>
                </li>
                {/* Login/Profile/Logout options beside Get Started */}
                {!isAuthenticated ? (
                  <li>
                    <button
                      onClick={(event) => {
                        event.preventDefault();
                        navigate("/signin");
                      }}
                      className="header-login-btn"
                    >
                      Login
                    </button>
                  </li>
                ) : (
                  <li>
                    <div className="profile-menu-container">
                      <ProfileMenu
                        trigger={
                          <div className="profile-icon-wrapper">
                            <ProfileIcon userImage={userImage} />
                          </div>
                        }
                      >
                        <ProfileMenuItem onClick={() => navigate("/userprofile")}>
                          <FaUserCircle size={22} /> Profile
                        </ProfileMenuItem>
                        <ProfileMenuItem>
                          <IoSettingsOutline size={22} /> Setting
                        </ProfileMenuItem>
                        <ProfileMenuItem>
                          <FiLogOut size={20} /> <Logout />
                        </ProfileMenuItem>
                      </ProfileMenu>
                    </div>
                  </li>
                )}
              </ul>
            )}

            {/* Authenticated pages - show app selector and profile */}
            {isAuthenticated && location.pathname !== "/" && 
             !location.pathname.includes("/analytics") && 
             !location.pathname.includes("/billing") && 
             !location.pathname.includes("/settings") && 
             !location.pathname.includes("/manage-users") && (
              <div className="header-nav-items-authenticated">
                {/* Application Selector Dropdown - Always visible for authenticated users */}
                {apps.length > 0 && (
                  <div className="app-selector-container" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div>
                      <label className="app-selector-label">Choose Application</label>
                      <select
                        className="app-selector-dropdown"
                        value={selectedApp?.appName || selectedApp?.name || ""}
                        onChange={handleAppChange}
                        disabled={loadingApps}
                      >
                        {loadingApps ? (
                          <option>Loading apps...</option>
                        ) : apps.length === 0 ? (
                          <option>No applications</option>
                        ) : (
                          <>
                            <option value="">Select Application</option>
                            {apps.map((app) => (
                              <option key={app.appName || app.name} value={app.appName || app.name}>
                                {app.appName || app.name}
                              </option>
                            ))}
                          </>
                        )}
                      </select>
                    </div>
                    {/* App Preview Button */}
                    {selectedApp && (
                      <AppPreviewModal appName={selectedApp?.appName || selectedApp?.name} />
                    )}
                  </div>
                )}

                <div className="profile-menu-container">
                  <ProfileMenu
                    trigger={
                      <div className="profile-icon-wrapper">
                        <ProfileIcon userImage={userImage} />
                      </div>
                    }
                  >
                    <ProfileMenuItem onClick={() => navigate("/userprofile")}>
                      <FaUserCircle size={22} /> Profile
                    </ProfileMenuItem>
                    <ProfileMenuItem>
                      <IoSettingsOutline size={22} /> Setting
                    </ProfileMenuItem>
                    <ProfileMenuItem>
                      <FiLogOut size={20} /> <Logout />
                    </ProfileMenuItem>
                  </ProfileMenu>
                </div>
              </div>
            )}

          </div>
        </nav>
      </header>
    </>
  );
};

export default Header;
// 🔧 fixed/updated by ChatGPT on 2025-10-18 17:59:00 – reason: replaced profileStore undefined reference with useProfileStore hook for proper Zustand integration (END)
